import { Box, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import AppraiseeSnapshot from "./Widgets/AppraiseeSnapshot";
import DimensionScore from "./Widgets/DimensionScore";
import FeatureIDs from "../../../Utils/Common/FeatureIDs";
import {
  getData,
  getUserId,
  submitPayload,
} from "../../../Utils/Common/Library";
import { useDispatch } from "react-redux";
import { Actions } from "../../../Redux/Actions/Actiontypes";
import PlanScores from "./Widgets/PlanScores";
import OverallComments from "./Widgets/OverallComments";
import { getFinalPeriod } from "../Dimension/Phases/PeriodMap";
import Atomic from "../../../AComponent/Atomic";
import { WorkflowProcesser } from "../Dimension/WorkflowProcesser";
import AlertMessage from "../../../Utils/Messages/AlertMessage";
import EwModal from "../../../MComponent/Modal/Modal";
import AppraiseeActions from "./AppraiseeActions";
import { useHistory } from "react-router-dom";
import ScorePreview from "../Dimension/Modals/ScorePreview";
import Warning from "../Dimension/Phases/Warning";

const { Button } = Atomic;

const AttendanceWidgetProps = {
  AttendanceWidgetDaysWorked: "",
  AttendanceWidgetHours: "",
  AttendanceWidgetPunctualityRecord: "",
  AttendanceWidgetPunctuality: "",
};

const AppraiseeSnapshotWidgetProps = {
  SnapShotWidgetEmployeeType: "",
  SnapShotWidgetDesignation: "",
  SnapShotWidgetRole: "",
  SnapShotWidgetEmployee: "",
  SnapShotWidgetLocation: "",
  SnapShotWidgetName: "",
  SnapShotWidgetGrade: "",
  SnapShotWidgetFunction: "",
};

const ScoresWidgetProps = {
  SummaryCommentsWidget: "",
  SummaryDimensionScores: "",
  SummaryPlanAggregateScoreWidget: "",
  SummaryMultiRaterScoreWidget: "",
  SummaryPlanAggregateScore: "",
  SummaryPlanModerateScore: "",
};

const AggregatePlanScoreProps = {
  AggregatePlanScore: "",
  AggregateFinalScore: "",
  AggregateScoreDisplay: "",
  AggregateRatingScaleID: "",
};

const ModeratedPlanScoreProps = {
  ModeratedPlanScore: "",
  ModeratedPlanScoreFinalScore: "",
};

const AssessorPlanScoreProps = {
  AssessorPlanScore: "",
  AssessorPlanRater: "",
  AssessorPlanFinalScore: "",
  AssessorPlanRatingScaleId: "",
};

const AdjustedPlanScoreProps = {
  AdjustedPlanScore: "",
  AdjustedPlanScoreDisplay: "",
  AdjustedPlanFinalScore: "",
  AdjustedPlanScoreRatingScaleID: "",
};

function SubmitAlert({ message, closeAlert, onSubmit, onCancel }) {
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  return (
    <Box sx={{ padding: "0.5em" }}>
      <Typography variant="h6" fontWeight={"400"} width={"30vw"}>
        {message}
        {/* <b>{name}</b> */}
      </Typography>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: "flex-end",
          marginTop: "2em",
        }}
      >
        <Button
          color={"info"}
          variant={"text"}
          title={"Cancel"}
          onClick={() => {
            closeAlert();
            onCancel();
          }}
        />
        <Button
          color={"info"}
          variant={"contained"}
          style={{ marginLeft: "1em" }}
          title={"Continue"}
          isLoading={loading}
          onClick={() => {
            setLoading(true);
            onSubmit().then(() => {
              setLoading(false);
              const location =
                localStorage.getItem("EPP_NAV_LOCATION") || "/myteamplan";
              localStorage.clear("EPP_NAV_LOCATION");
              history.push(location);
              window.location.reload();
            });
          }}
        />
      </Box>
    </Box>
  );
}

const Summary = ({ planStore, handleTabEdit }) => {
  const { EPP, MPP, Confidential } = planStore || {};

  const dispatch = useDispatch();
  dispatch({ type: Actions.ADD_SIDE_COMPONENT, payload: null });

  const [pendingWithAppraiser, setPendingWithAppraiser] = useState(false);
  const [actionError, setActionError] = useState(null);
  const [appraiserAssessments, setAppraiserAssessments] = useState([]);
  const [appraiserLoading, setAppraiserLoading] = useState(false);
  const [FinalAssessments, setFinalAssessments] = useState({});
  const [document, setDocument] = useState({
    ...AppraiseeSnapshotWidgetProps,
    ...AttendanceWidgetProps,
    ...ScoresWidgetProps,
  });

  async function getDimensionAssessmentDocs(DimensionID) {
    const dimension = planStore?.Dimensions[DimensionID];
    if (!dimension) {
      const res = await getData({
        featureId: FeatureIDs.ParameterAsseessment,
        payload: {
          "Data.AppraiseeUserID": EPP.AppraiseeUserID,
          "Data.DimensionID": DimensionID,
          "Data.EmployeePerformancePlanID": EPP.TransactionID,
        },
        fields: ["Header", "Data", "Workflow"],
      });
      return (res?.Data || []).filter(Boolean);
    }
    return dimension.ParameterAssessments.filter(Boolean);
  }

  useEffect(() => {
    const SummaryDocument = {};

    for (let key in {
      ...AppraiseeSnapshotWidgetProps,
      ...AttendanceWidgetProps,
      ...ScoresWidgetProps,
      ...AggregatePlanScoreProps,
      ...ModeratedPlanScoreProps,
      ...AssessorPlanScoreProps,
      ...AdjustedPlanScoreProps,
    }) {
      SummaryDocument[key] = MPP[key];
    }

    setDocument(SummaryDocument);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function editEPP() {
    const edit = {
      TransactionID: EPP.TransactionID,
      EffectiveFromTimestamp: EPP.EffectiveFromTimestamp,
      RequestType: "1",
    };

    await submitPayload({
      featureId: FeatureIDs.EmployeePerformancePlan,
      edit,
      payload: {
        ...EPP,
      },
    });
  }

  async function editDimension(ParameterAssessment, ActionType) {
    const Header = ParameterAssessment.Header;
    const Data = ParameterAssessment.Data;
    const Workflow = ParameterAssessment.Workflow;

    const workflowProcesser = new WorkflowProcesser(Workflow);
    let stepId = workflowProcesser.getCurrentStepID();
    const WorkflowID = Workflow.WorkflowID;
    let obj = {
      stepId,
      action: ActionType,
      WorkflowID,
    };

    let edit = {
      TransactionID: Header.TransactionID,
      EffectiveFromTimestamp: Header.EffectiveFromTimestamp,
    };

    return await submitPayload(
      ActionType
        ? {
            featureId: "19152",
            payload: Data,
            updateAction: obj,
            edit,
          }
        : {
            featureId: "19152",
            payload: Data,
            edit,
          }
    );
  }

  async function editConfidentialAssessment() {
    if (!Confidential) return;
    console.log(Confidential, "confidentialPayload");
    const FINAL_PAYLOAD = {
      EmployeePlanID: Confidential.EmployeePlanID,
      PerformancePlanID: Confidential.PerformancePlanID,
      AppraiseeUserID: Confidential.AppraiseeUserID,
      AppraiserUserID: getUserId(),
      PerformanceSummary: Confidential.PerformanceSummary,
      PotentialSummary: Confidential.PotentialSummary,
      GrowthReadiness: Confidential.GrowthReadiness,
      GrowthRoleID: Confidential.GrowthRoleID,
      PromotionRecommendation: Confidential.PromotionRecommendation,
      ExitRisk: Confidential.ExitRisk,
    };

    const edit = {
      TransactionID: Confidential.TransactionID,
      EffectiveFromTimestamp: Confidential.EffectiveFromTimestamp,
      RequestType: "1",
    };

    await submitPayload({
      featureId: FeatureIDs.ConfidentialAssessment,
      payload: FINAL_PAYLOAD,
      edit,
    })
      .then((res) => {})
      .catch((e) => {
        setActionError({ type: 1, message: "Something went wrong" });
      })
      .finally(() => {});
  }

  useEffect(() => {
    function getFinalPeriodAssessment(data) {
      if (typeof data === "string" || !data) return undefined;

      let PeriodType = data[0]?.Data?.ReviewPeriodType;
      let ParameterAssessment = null;
      if (PeriodType) {
        ParameterAssessment = data.find(
          (assess) =>
            assess.Data.ReviewPeriodType === PeriodType &&
            (PeriodType !== "I"
              ? assess.Data.ReviewPeriodUnit === getFinalPeriod(PeriodType)
              : true)
        );
      }
      return ParameterAssessment;
    }

    function validateAssessment(a, isValid) {
      if (!a) return null;

      const Workflow = a.Workflow;

      if (Workflow && Workflow.WorkflowSteps) {
        const processor = new WorkflowProcesser(Workflow);
        if (
          processor.getCurrentStepData()?.StepOwnerLabel === "Appraiser" &&
          processor.getCurrentStepUserID() === getUserId()
        ) {
          if (!pendingWithAppraiser && isValid) {
            setPendingWithAppraiser(true);
          }
          console.log(
            processor.getCurrentStepData(),
            "processor.getCurrentStepData()"
          );
          return processor;
        }
      }
      return undefined;
    }

    if (EPP.Dimensions.length === 2) {
      getDimensionAssessmentDocs(EPP.Dimensions[0].DimensionID).then((res1) => {
        getDimensionAssessmentDocs(EPP.Dimensions[1].DimensionID).then(
          (res2) => {
            const data = {
              [EPP.Dimensions[0].DimensionID]: [],
              [EPP.Dimensions[1].DimensionID]: [],
            };

            const d1 = getFinalPeriodAssessment(res1);
            const d2 = getFinalPeriodAssessment(res2);

            const valid = [null, null];

            const goalsAssessment = res1.find(
              (d) => d.Workflow.WorkflowStatus !== "C"
            );
            const coreValues = res2.find(
              (d) => d.Workflow.WorkflowStatus !== "C"
            );

            const goalsProcessor = validateAssessment(
              goalsAssessment,
              goalsAssessment && coreValues ? true : false
            );
            const coreValuesProcessor = validateAssessment(
              coreValues,
              goalsAssessment && coreValues ? true : false
            );

            if (goalsProcessor) {
              valid[0] = {
                data: goalsAssessment,
                actionType:
                  goalsProcessor.getCurrentStepData()?.AllowedActions[0],
              };
            }
            if (coreValuesProcessor) {
              valid[1] = {
                data: coreValues,
                actionType:
                  coreValuesProcessor.getCurrentStepData()?.AllowedActions[0],
              };
            }
            setAppraiserAssessments(valid);

            if (d1) {
              data[EPP.Dimensions[0].DimensionID].push(d1);
            }
            if (d2) {
              data[EPP.Dimensions[1].DimensionID].push(d2);
            }
            setFinalAssessments({
              ...data,
            });
          }
        );
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function getAppraiseeCondition() {
    const DimensionID = EPP.Dimensions[0].DimensionID;

    const assessments = FinalAssessments[DimensionID]; // Final period assess of Goals

    if (EPP.AppraiseeUserID === getUserId()) {
      if (assessments.length === 0) return false; // User will not see

      const doc = assessments[0];
      if (doc) {
        const Workflow = doc.Workflow;
        if (Workflow.WorkflowStatus === "C") return true;
        const processor = new WorkflowProcesser(Workflow);
        const currentStep = processor.getCurrentStepData();
        const isModeratorDone = (Workflow?.WorkflowSteps || []).find(
          (s) =>
            s.StepType === "Actioned" &&
            s.StepOwnerLabel === "Moderator" &&
            s.StepAction === "Confirm"
        )
          ? true
          : false;
        if (currentStep?.StepOwnerLabel === "Appraisee" && isModeratorDone)
          return true;
      }
      return false;
    } else {
      return true;
    }
  }

  function delay(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  async function saveEPPConfidentialGoalsCoreValues() {
    try {
      setModal({
        Component: Warning,
        props: {
          message:
            "Please do not refresh the page or close this window while your plan is being saved! We will refresh the page once your plan is saved successfully",
        },
      });
      setAppraiserLoading(true);
      await editEPP();
      await editConfidentialAssessment();
      if (appraiserAssessments[0]) {
        await editDimension(appraiserAssessments[0].data, undefined);
      }
      if (appraiserAssessments[1]) {
        await delay(4000);
        await editDimension(appraiserAssessments[1].data, undefined);
      }
      setAppraiserLoading(false);
      setActionError({
        type: 0,
        message: "Saved Plan Successfully",
      });
      setModal(null);
    } catch (e) {
      setActionError({
        type: 1,
        message: e,
      });
      setModal(null);
    }
  }

  function isValidAssessment(assessment) {
    const parameters = assessment?.Data.Parameters;
    if (parameters) {
      for (let i = 0; i < parameters.length; i++) {
        const parameter = parameters[i];
        const index = parameter?.ActorAssessments?.findIndex(
          (a) => a.ActorType === "Appraiser"
        );
        if (index && index !== -1) {
          const data = parameter?.ActorAssessments[index];
          if (
            data.RatingScaleValueID === "" ||
            data.RatingScaleValueID === -1
          ) {
            return false;
          }
        } else {
          return false;
        }
      }
      return true;
    } else {
      return false;
    }
  }

  const [modal, setModal] = useState(null);

  async function submitEPPConfidentialGoalsCoreValues() {
    try {
      if (EPP.AppraiserOverallComments) {
        setAppraiserLoading(true);
        if (appraiserAssessments[0] && appraiserAssessments[1]) {
          if (
            appraiserAssessments[0].data.Data.ReviewPeriodUnit ===
            appraiserAssessments[1].data.Data.ReviewPeriodUnit
          ) {
            if (
              isValidAssessment(appraiserAssessments[0].data) &&
              isValidAssessment(appraiserAssessments[1].data)
            ) {
              if (
                appraiserAssessments[0].data.Data.ReviewPeriodUnit ===
                  getFinalPeriod(
                    appraiserAssessments[0].data.Data.ReviewPeriodType
                  ) &&
                appraiserAssessments[1].data.Data.ReviewPeriodUnit ===
                  getFinalPeriod(
                    appraiserAssessments[1].data.Data.ReviewPeriodType
                  )
              ) {
                setModal({
                  Component: SubmitAlert,
                  props: {
                    message:
                      "Caution: Ensure thorough completion of all appraisal sections before proceeding. Once advanced to the next stage, editing will be restricted. Double-check your inputs to avoid any unintended consequences.",
                    closeAlert: () => {
                      setModal(null);
                    },
                    onCancel: () => {
                      setAppraiserLoading(false);
                      setModal(null);
                    },
                    onSubmit: async () => {
                      setModal({
                        Component: Warning,
                        props: {
                          message:
                            "Please do not refresh the page or close this window while your plan is being submitted! We will redirect you to Team Plans once your plan is submitted successfully",
                        },
                      });
                      await editEPP();
                      await editConfidentialAssessment();
                      await editDimension(
                        appraiserAssessments[0].data,
                        appraiserAssessments[0].actionType
                      );
                      await delay(4000);
                      await editDimension(
                        appraiserAssessments[1].data,
                        appraiserAssessments[1].actionType
                      );
                      setActionError({
                        type: 0,
                        message: "Plan submitted successfully",
                      });
                      setModal(null);
                    },
                  },
                });
              }
            } else {
              setActionError({
                type: 1,
                message:
                  "Assessment is not completely done in one of the dimension! Saved Partial Plan Only",
              });
            }
          } else {
            setActionError({
              type: 1,
              message:
                "Assessments in both dimensions are not in same review period! Saved Partial Plan Only",
            });
          }
        } else {
          setActionError({
            type: 1,
            message:
              "Assessments not started in some dimensions! Saved Partial Plan Only",
          });
        }
        setAppraiserLoading(false);
      } else {
        setActionError({
          type: 1,
          message: "Appraiser Overall Comments are required",
        });
        setModal(null);
      }
    } catch (e) {
      setActionError({
        type: 1,
        message: e,
      });
    }
  }

  return (
    <>
      <Box
        display={"flex"}
        gap={"1em"}
        alignItems={"stretch"}
        flexWrap={"wrap"}
      >
        <Box
          display={"flex"}
          flexDirection={"column"}
          gap="1em"
          flexBasis={"23rem"}
          flexGrow={"0"}
          flexShrink={"0.3"}
        >
          <Box>
            {[
              ...Object.keys(AppraiseeSnapshotWidgetProps).map(
                (key) => document[key]
              ),
            ].includes("E") && (
              <AppraiseeSnapshot
                EPP={EPP}
                {...Object.keys(AppraiseeSnapshotWidgetProps).reduce(
                  (total, current) => {
                    total[current] = document[current];
                    return total;
                  },
                  {}
                )}
              />
            )}
          </Box>
          {Object.keys(FinalAssessments).length > 0 && (
            <Box>
              <PlanScores
                EPP={EPP}
                handleTabEdit={handleTabEdit}
                FinalAssessments={FinalAssessments}
                AggregatePlanScores={{
                  ...Object.keys(AggregatePlanScoreProps).reduce(
                    (total, current) => {
                      total[current] = document[current];
                      return total;
                    },
                    {}
                  ),
                }}
                ModeratedPlanScores={{
                  ...Object.keys(ModeratedPlanScoreProps).reduce(
                    (total, current) => {
                      total[current] = document[current];
                      return total;
                    },
                    {}
                  ),
                }}
                AssessorPlanScores={{
                  ...Object.keys(AssessorPlanScoreProps).reduce(
                    (total, current) => {
                      total[current] = document[current];
                      return total;
                    },
                    {}
                  ),
                }}
                AdjustedPlanScores={{
                  ...Object.keys(AdjustedPlanScoreProps).reduce(
                    (total, current) => {
                      total[current] = document[current];
                      return total;
                    },
                    {}
                  ),
                }}
              />
            </Box>
          )}
        </Box>
        {getUserId() !== EPP.AppraiseeUserID &&
          document.SummaryDimensionScores &&
          document.SummaryDimensionScores.map((dimension) => {
            return Object.values(dimension).includes("E") ? (
              <Box flexBasis={"25vw"} flexGrow={"1"}>
                <DimensionScore
                  EPP={EPP}
                  handleTabEdit={handleTabEdit}
                  DimensionScoreRules={dimension}
                  key={dimension.DimensionID}
                />
              </Box>
            ) : (
              <></>
            );
          })}
        {Object.keys(FinalAssessments).length > 0 &&
          FinalAssessments[EPP.Dimensions[0].DimensionID].length > 0 &&
          FinalAssessments[EPP.Dimensions[1].DimensionID].length > 0 &&
          getAppraiseeCondition() && (
            <Box flexBasis={"25rem"}>
              <OverallComments
                EPP={EPP}
                FinalAssessments={FinalAssessments}
                handleTabEdit={handleTabEdit}
              />
            </Box>
          )}
      </Box>
      <br />
      <br />
      {actionError && (
        <AlertMessage
          {...actionError}
          onClose={() => {
            setActionError(null);
          }}
          autoClose={true}
          autoCloseTime={3000}
        />
      )}
      <br />
      {pendingWithAppraiser && (
        <Box sx={{ display: "flex", gap: "1em" }}>
          <Button
            label={"Save Plan"}
            onClick={() => {
              saveEPPConfidentialGoalsCoreValues();
            }}
            isLoading={appraiserLoading}
          />
          <Button
            label={"Submit Plan"}
            onClick={() => {
              const dimensionRoundingMap = {};
              (MPP?.Dimension || []).forEach((d) => {
                dimensionRoundingMap[d.DimensionID] = {
                  ScoreRounding: d.ScoreRounding,
                  RoundingValue: d.RoundingValue,
                  PlanDimensionWeight: d.PlanDimensionWeight,
                };
              });
              setModal({
                Component: ScorePreview,
                props: {
                  goalsAssessments: appraiserAssessments[0]?.data,
                  coreValuesAssessments: appraiserAssessments[1]?.data,
                  showAggregate: true,
                  aggregateRounding: MPP?.AggregateRounding,
                  dimensionRoundingMap,
                  onConfirm: () => {
                    submitEPPConfidentialGoalsCoreValues();
                  },
                  onCancel: () => {
                    setModal(null);
                  },
                },
              });
            }}
            isLoading={appraiserLoading}
          />
        </Box>
      )}
      <AppraiseeActions FinalAssessments={FinalAssessments} />
      {modal && (
        <EwModal open={modal} onClose={() => {}}>
          <modal.Component {...modal.props} />
        </EwModal>
      )}
    </>
  );
};

export default Summary;
